
(function() {
  var module = {};
  var result = {};
  module.exports = { "en": { "i18n": { "duration": { "seconds": "{{ seconds }} sec", "minutes": "{{ minutes }} min", "hours": "{{ hours }} hr", "hoursAndMinutes": "{{ hours }} hr {{ minutes }} min", "days": "{{ days }} days", "shortForm": { "seconds": "{{ seconds }}s", "minutes": "{{ minutes }}m", "hours": "{{ hours }}h", "days": "{{ days }}d", "hoursAndMinutes": "{{ hours }}h {{ minutes }}m" } }, "dateTime": { "shortForm": { "months": { "january": "Jan", "february": "Feb", "march": "Mar", "april": "Apr", "may": "May", "june": "Jun", "july": "Jul", "august": "Aug", "september": "Sep", "october": "Oct", "november": "Nov", "december": "Dec" } }, "monthAndDay": "{{monthName}} {{dayNumber}}", "monthAndYear": "{{monthName}} {{yearNumber}}" }, "numberRepresentation": { "fraction": "{{ numerator }}/{{ denominator }}" } } } };
  result.translations = module.exports;
  result.translationsLoaded = {
  "I18n": {
    "en": "static-7.418"
  }
};
  result.translationsAvailable = {
  "I18n": {
    "cs": "static-7.418",
    "da": "static-7.418",
    "de": "static-7.418",
    "el": "static-7.418",
    "en": "static-7.418",
    "es-mx": "static-7.418",
    "es": "static-7.418",
    "fi": "static-7.418",
    "fr": "static-7.418",
    "it": "static-7.418",
    "ja": "static-7.418",
    "ko": "static-7.418",
    "nl": "static-7.418",
    "no": "static-7.418",
    "pl": "static-7.418",
    "pt-br": "static-7.418",
    "sv": "static-7.418",
    "zh-cn": "static-7.418",
    "zh-hk": "static-7.418"
  }
};
  hns('I18n', result);
  if (typeof I18n === 'object' && I18n.trigger) { I18n.trigger('loaded:I18n:en', {version: 'static-7.418'}); }
})();


